
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pool]",
      function () {
        return require("private-next-pages/[pool]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pool]"])
      });
    }
  